import React, { useState, useEffect, useRef } from 'react';
import { connect } from 'react-redux';
import { Redirect, useHistory } from 'react-router-dom';
import {
  Row,
  Col,
  NavbarBrand,
  Input,
  Form,
  Button,
  Collapse,
  FormGroup,
  Label,
  Badge,
} from 'reactstrap';
import frozberiesLogo from '../images/frozberries-logo.png';
import StepWizard from 'react-step-wizard';
import UserInfo from './UserInfo';
import Payment from './Payment';
import BadgeMT from '@material-ui/core/Badge';
import Shipping from './Shipping';
import CheckoutNavBar from './CheckoutNavBar';
import { Helmet } from 'react-helmet';
import LoadingOverlay from 'react-loading-overlay';
import { couponInputUpdate, applyCoupon, resetCouponError } from '../actions/discountActions';
import ButtonSpinner from './ButtonSpinner';
import classnames from 'classnames';
import { validateCart, resetWarnings } from '../actions/shoppingCart';
import { setShippingFee } from '../actions/checkOutActions';

const Checkout = ({
  shoppingCart,
  checkout,
  guest,
  auth,
  orders,
  discount,
  setShippingFee,
  couponInputUpdate,
  applyCoupon,
  validateCart,
  resetWarnings,
  resetCouponError,
}: any) => {
  const history = useHistory();
  const [isOpen, setIsOpen] = useState(false);
  const prevOrderRef = useRef(orders.order);
  const prevDiscountErrorsRef = useRef(discount.errors);
  const prevCartRef = useRef(shoppingCart.cart);

  useEffect(() => {
    let data: any = {};
    data.cart = shoppingCart.cart;

    if (guest.userid !== '') {
      data.userid = guest.userid;
    }
    if (auth.isAuthenticated) {
      data.userid = auth.user.id;
    }

    validateCart(data);

    return () => {
      resetWarnings();
    };
  }, []);

  useEffect(() => {
    if (orders.order !== prevOrderRef.current) {
      history.push({
        pathname: `/order-received/${orders.order._id}`,
        state: {
          order: orders.order,
        },
      });
    }
    prevOrderRef.current = orders.order;
  }, [orders.order]);

  useEffect(() => {
    if (
      discount.errors !== prevDiscountErrorsRef.current &&
      Object.keys(discount.errors).length > 0
    ) {
      const timer = setTimeout(resetCoupon, 4000);
      return () => clearTimeout(timer);
    }
    prevDiscountErrorsRef.current = discount.errors;
  }, [discount.errors]);

  useEffect(() => {
    if (shoppingCart.cart !== prevCartRef.current && shoppingCart.cart.length === 0) {
      setShippingFee(0);
    }
    prevCartRef.current = shoppingCart.cart;
  }, [shoppingCart.cart]);

  const updateCoupon = (e) => {
    var field = e.target.name;
    var inputValue = e.target.value;
    couponInputUpdate(field, inputValue);
  };

  const handleCoupon = (e) => {
    e.preventDefault();
    let couponData: any = {};
    couponData.coupon = discount.coupon;
    applyCoupon(couponData);
  };

  const toggle = () => {
    setIsOpen(!isOpen);
  };

  const resetCoupon = () => {
    resetCouponError();
  };

  let subTotal = 0;

  if (shoppingCart.cart.length !== 0) {
    subTotal =
      Math.round(
        shoppingCart.cart
          .map((eachItem) => eachItem.quantity * eachItem.product.price)
          .reduce((total, currentValue) => total + currentValue) * 100
      ) / 100;
  }

  let total = subTotal;
  let discount_amount;

  if (checkout.shippingFee !== null) {
    total = total + checkout.shippingFee;
  }

  if (Object.keys(discount.userCoupon).length > 0) {
    if (subTotal >= discount.userCoupon.minimumSpend) {
      if (discount.userCoupon.isPercent) {
        discount_amount = (subTotal / 100) * discount.userCoupon.amount;
      } else {
        discount_amount = discount.userCoupon.amount;
      }
    }
  }

  if (discount_amount !== undefined) {
    total = total - discount_amount;
  }
  if (total < 0) {
    total = 0;
  }

  if (shoppingCart.cart.length === 0 && shoppingCart.warnings.length === 0) {
    return <Redirect to="/cart" />;
  }

  return (
    <LoadingOverlay active={checkout.fullPageLoading} spinner>
      <div className="border" style={{ minHeight: '100vh' }}>
        <div>
          <Helmet>
            <title>Checkout - Frozberries Victoria</title>
            <meta name="description" content="Checkout - Frozberries Victoria" />
          </Helmet>
        </div>

        <Row className="mt-3 checkout-row">
          <Col lg={7} className="border-right">
            <NavbarBrand href="/" className="w-100 text-center">
              <img src={frozberiesLogo} alt="frozberries-logo" />
            </NavbarBrand>
            <div
              className="px-3 border-top border-bottom mt-3 d-lg-none"
              onClick={toggle}
              style={{ cursor: 'pointer' }}
            >
              <p className="pt-3">
                <i className="fas fa-shopping-cart pr-2"></i>
                Show order summary
                <i className="fas fa-chevron-down pl-2"></i>
                <span className="float-right">
                  AU $
                  {(
                    Math.round(
                      (shoppingCart.cart.length !== 0
                        ? shoppingCart.cart
                            .map((eachItem) => eachItem.quantity * eachItem.product.price)
                            .reduce((total, currentValue) => total + currentValue)
                        : 0) * 100
                    ) /
                      100 +
                    checkout.shippingFee
                  ).toFixed(2)}
                </span>
              </p>
            </div>
            <Collapse isOpen={isOpen} className="mx-4 d-lg-none">
              {shoppingCart.cart.map((product) => (
                <div key={product.product._id} className="border-bottom">
                  <Row className="px-2 py-3 ">
                    <Col xs="2">
                      <BadgeMT
                        badgeContent={product.quantity}
                        color="error"
                        anchorOrigin={{
                          vertical: 'top',
                          horizontal: 'right',
                        }}
                      >
                        <img
                          src={product.product.image}
                          alt={product.product.name}
                          style={{ height: 60 }}
                        />
                      </BadgeMT>
                    </Col>
                    <Col xs="10">
                      <div className="pt-2">
                        <span className="w-75 d-inline float-left  pl-3">
                          {' '}
                          {product.product.name}
                        </span>
                        <span className=" text-muted  font-weight-bold w-25 float-right pl-2">
                          {' '}
                          $
                          {(
                            Math.round(product.product.price * product.quantity * 100) / 100
                          ).toFixed(2)}
                        </span>
                      </div>
                    </Col>
                  </Row>
                  {shoppingCart.warnings.map(
                    (eachWarning) =>
                      eachWarning.product._id === product.product._id && (
                        <Row className="px-4 py-1 ">
                          <p className="font-weight-bold text-info">{eachWarning.definition}</p>
                        </Row>
                      )
                  )}
                </div>
              ))}

              {shoppingCart.warnings.map(
                (eachWarning) =>
                  !eachWarning.product.inStock && (
                    <div key={eachWarning.product._id} className="border-bottom">
                      <Row className="px-2 py-3">
                        <Col xs="2">
                          <img
                            src={eachWarning.product.image}
                            alt={eachWarning.product.name}
                            style={{ height: 60 }}
                          />
                        </Col>
                        <Col xs="10">
                          <div className="pt-2">
                            <span className="w-75 d-inline float-left  pl-3">
                              {' '}
                              {eachWarning.product.name}
                            </span>
                          </div>
                        </Col>
                      </Row>
                      <Row className="px-4 py-1 ">
                        <p className="font-weight-bold text-danger">{eachWarning.definition}</p>
                      </Row>
                    </div>
                  )
              )}

              <Form className="my-3 border-bottom">
                <FormGroup>
                  <Input
                    name="coupon"
                    className={classnames(' d-inline', {
                      'is-invalid': discount.errors.coupon,
                    })}
                    value={discount.coupon}
                    onChange={updateCoupon}
                    placeholder="Gift cart or discount code"
                  />
                  <div className="invalid-feedback">{discount.errors.coupon}</div>
                </FormGroup>
                <Button
                  size="sm"
                  color="success"
                  className="my-2 mb-3"
                  disabled={discount.coupon === ''}
                  outline
                  onClick={handleCoupon}
                >
                  {discount.loading ? <ButtonSpinner /> : <span>Apply</span>}
                </Button>
              </Form>

              <div className="border-bottom">
                <p>
                  SubTotal <span className="float-right">AU ${subTotal.toFixed(2)}</span>
                </p>
                <p>
                  Shipping
                  <span
                    className="float-right"
                    style={{
                      fontSize: checkout.shippingFee === null ? 12 : 16,
                    }}
                  >
                    {checkout.shippingFee === null
                      ? 'Not yet calculated'
                      : checkout.shippingFee === 0
                        ? 'Free'
                        : 'AU $' + checkout.shippingFee.toFixed(2)}
                  </span>
                </p>
                {Object.keys(discount.userCoupon).length > 0 && (
                  <React.Fragment>
                    <p>
                      Discount{' '}
                      <span className="float-right">
                        {discount.userCoupon.isPercent ? '%' : 'AU $'}
                        {discount.userCoupon.amount}
                      </span>
                      {subTotal < discount.userCoupon.minimumSpend && (
                        <React.Fragment>
                          <br />
                          <span className="text-danger" style={{ fontSize: 12 }}>
                            Minimum spend of AU ${discount.userCoupon.minimumSpend} is required.
                            Otherwise discount won't be applied.
                          </span>
                        </React.Fragment>
                      )}
                    </p>
                    {discount_amount !== undefined && (
                      <p className="text-danger">
                        Discount{' '}
                        <h6 className="d-inline">
                          <Badge color="danger">
                            <i className="fas fa-tags"></i> {discount.userCoupon.code}
                          </Badge>
                        </h6>{' '}
                        <span className="float-right text-danger">
                          - AU ${discount_amount.toFixed(2)}
                        </span>
                      </p>
                    )}
                  </React.Fragment>
                )}
              </div>
              <div className="my-3">
                <h4>
                  Total <span className="float-right">AU ${total.toFixed(2)}</span>
                </h4>
              </div>
            </Collapse>

            {checkout.errors.noMatch && (
              <Row className="py-3">
                <Col>
                  <Label className="text-danger">{checkout.errors.noMatch}</Label>
                </Col>
              </Row>
            )}

            <StepWizard nav={<CheckoutNavBar />} isHashEnabled={true}>
              <Shipping hashKey={'shipping'} />
              <UserInfo hashKey={'userDetails'} />
              <Payment hashKey={'payment'} />
            </StepWizard>
          </Col>

          <Col lg={5} className="px-5 d-none d-lg-block">
            {shoppingCart.cart.map((product) => (
              <div key={product.product._id} className="border-bottom">
                <Row className="px-2 py-3 ">
                  <Col xs="2">
                    <BadgeMT
                      badgeContent={product.quantity}
                      color="error"
                      anchorOrigin={{
                        vertical: 'top',
                        horizontal: 'right',
                      }}
                    >
                      <img
                        src={product.product.image}
                        alt={product.product.name}
                        style={{ height: 60 }}
                      />
                    </BadgeMT>
                  </Col>
                  <Col xs="10">
                    <div className="pt-2">
                      <span className="w-75 d-inline float-left  pl-3">
                        {' '}
                        {product.product.name}
                      </span>
                      <span className=" text-muted  font-weight-bold w-25 float-right pl-2">
                        {' '}
                        $
                        {(Math.round(product.product.price * product.quantity * 100) / 100).toFixed(
                          2
                        )}
                      </span>
                    </div>
                  </Col>
                </Row>

                {shoppingCart.warnings.map(
                  (eachWarning) =>
                    eachWarning.product._id === product.product._id && (
                      <Row className="px-4 py-1 ">
                        <p className="font-weight-bold text-danger">{eachWarning.definition}</p>
                      </Row>
                    )
                )}
              </div>
            ))}
            {shoppingCart.warnings.map(
              (eachWarning) =>
                !eachWarning.product.inStock && (
                  <div key={eachWarning.product._id} className="border-bottom">
                    <Row className="px-2 py-3">
                      <Col xs="2">
                        <img
                          src={eachWarning.product.image}
                          alt={eachWarning.product.name}
                          style={{ height: 60 }}
                        />
                      </Col>
                      <Col xs="10">
                        <div className="pt-2">
                          <span className="w-75 d-inline float-left  pl-3">
                            {' '}
                            {eachWarning.product.name}
                          </span>
                        </div>
                      </Col>
                    </Row>
                    <Row className="px-4 py-1 ">
                      <p className="font-weight-bold text-danger">{eachWarning.definition}</p>
                    </Row>
                  </div>
                )
            )}

            <Form className="my-3 border-bottom" onSubmit={handleCoupon}>
              <FormGroup>
                <Input
                  name="coupon"
                  className={classnames(' d-inline', {
                    'is-invalid': discount.errors.coupon,
                  })}
                  value={discount.coupon}
                  onChange={updateCoupon}
                  placeholder="Gift cart or discount code"
                />
                <div className="invalid-feedback">{discount.errors.coupon}</div>
                {Object.keys(discount.userCoupon).length > 0 && discount.coupon !== '' && (
                  <span style={{ fontSize: 12 }}>You can only use one coupon at a time.</span>
                )}
              </FormGroup>
              <Button
                size="sm"
                color="success"
                className="my-2 mb-3"
                disabled={discount.coupon === ''}
                outline
                onClick={handleCoupon}
              >
                {discount.loading ? <ButtonSpinner /> : <span>Apply</span>}
              </Button>
            </Form>

            <div className="border-bottom">
              <p>
                SubTotal <span className="float-right">AU ${subTotal.toFixed(2)}</span>
              </p>
              <p>
                Shipping
                <span
                  className="float-right"
                  style={{
                    fontSize: checkout.shippingFee === null ? 12 : 16,
                  }}
                >
                  {checkout.shippingFee === null
                    ? 'Not yet calculated'
                    : checkout.shippingFee === 0
                      ? 'Free'
                      : 'AU $' + checkout.shippingFee.toFixed(2)}
                </span>
              </p>
              {Object.keys(discount.userCoupon).length > 0 && (
                <React.Fragment>
                  <p>
                    Discount{' '}
                    <span className="float-right">
                      {discount.userCoupon.isPercent ? '%' : 'AU $'}
                      {discount.userCoupon.amount}
                    </span>
                    {subTotal < discount.userCoupon.minimumSpend && (
                      <React.Fragment>
                        <br />
                        <span className="text-danger" style={{ fontSize: 12 }}>
                          Minimum spend of AU ${discount.userCoupon.minimumSpend} is required.
                          Otherwise discount won't be applied.
                        </span>
                      </React.Fragment>
                    )}
                  </p>
                  {discount_amount !== undefined && (
                    <p className="text-danger">
                      Discount{' '}
                      <h6 className="d-inline">
                        <Badge color="danger">
                          <i className="fas fa-tags"></i> {discount.userCoupon.code.toUpperCase()}
                        </Badge>
                      </h6>{' '}
                      <span className="float-right text-danger">
                        - AU ${discount_amount.toFixed(2)}
                      </span>
                    </p>
                  )}
                </React.Fragment>
              )}
            </div>

            <div className="my-3">
              <h4>
                Total <span className="float-right">AU ${total.toFixed(2)}</span>
              </h4>
            </div>
          </Col>
        </Row>
      </div>
    </LoadingOverlay>
  );
};

const mapStateToProps = (state: any) => ({
  shoppingCart: state.cart,
  checkout: state.checkout,
  guest: state.guest,
  auth: state.form,
  orders: state.orders,
  discount: state.discount,
});

export default connect(mapStateToProps, {
  setShippingFee,
  couponInputUpdate,
  applyCoupon,
  validateCart,
  resetWarnings,
  resetCouponError,
})(Checkout);
